import { useState, useContext, useEffect, useRef } from 'react';
import TextPargraph from '../utils/TextParagraph';
import Avis from './avis/Avis';
import { Rating } from 'react-simple-star-rating';
import { AppContext, UserContext } from '../../AppContextProvider';
import { BrowserView, MobileView } from 'react-device-detect';
import { useFetch } from '../api/FetchApiData';
import { MediaUrl, TranslatedCountrie } from '../utils/media/Media';
import { isMobile } from 'react-device-detect';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { useNavigate, useParams } from 'react-router-dom';
import SwitchButton from '../utils/ToggleSwitch';
import icon_rikinaze from '../icons/rikinaze.webp';
import icon_delivery from '../icons/delivry.webp';
import icon_cash from '../icons/payment_cash.webp';
import icon_carte from '../icons/payment_carte.webp';
import icon_gifts from '../icons/payment_gifts.webp';
import icon_paypal from '../icons/payment_paypal.webp';
import DatePicker from 'react-multi-date-picker';
import EventCalendar from '../utils/Calendar/Calendar';
import { useTranslation } from 'react-i18next';

if (isMobile)
    import('./MobProduit.css').then(() => {});
else
    import('./produit.css').then(() => {});


export default function Produit({article_id})
{

    const [mainImage,setMainImage] = useState(null)
    const [UserState,setUserState] = useContext(UserContext);
    const fetchData = useFetch();
    const {id} = useParams();
    const navigator = useNavigate();
    const [AppState,setAppState] = useContext(AppContext);
    const {t} = useTranslation();
    const [article,setArticle] = useState({quantite:1,characteristics:[],images:[],is_kit:false,title:'',excluded_location_dates:[],description:'',info_tech:'',avis:[],price:'',stock:1,payment_modes:[],documents:[]});
    const [qteStatus, setQteStatus] = useState({color:'green',text:'en stock'});
    const [_DatePicker, setDatePicker] = useState(<DatePicker />);
    const [devise,setDevise] = useState(AppState.settings.devise==='euro'?'€':'KMF');


    const LoadArticle = (id)=>{
        fetchData.GetData('articles/?id='+id).then((result)=>{
            if(result.result)
            {
                let qte = 1;
                let f = UserState.panier.articles.find((element) => element.article.id === result.article.id)
                if(f!==undefined)
                    qte = f.quantity;
                if(result.article.is_location)
                {
                    console.log(result.article.excluded_location_dates.map(d=>parse_date(d.date)));
                }
                setArticle({...result.article,payment_modes:JSON.parse(result.article.payment_modes),quantite:qte});
                if(result.article.images.length>0)
                    setMainImage(MediaUrl(result.article.images[0].image));
            }
        })
    }

    const parse_date=(datestr)=>{
        //const [d,m,y] = datestr.split("/").map(Number);
        return new Date(datestr);
    }

    useEffect(()=>{
        if(article.quantite > article.stock)
            setQteStatus({color:'orangered', text:t('produit.stock-text'), Approvisionnement: ' '+article.approvisionnement});
        else
            setQteStatus({color:'green', text:t('produit.stock-text')});
    },[article.quantite])

    useEffect(()=>{
        if(!!id)
            LoadArticle(id);
        else
            navigator('/');
    },[])

    useEffect(()=>{
        if(!!id)
            LoadArticle(id)
    },[AppState.settings.lang,AppState.settings.devise])

    useEffect(()=>{
        setDevise(AppState.settings.devise==='euro'?'€':'KMF');
    },[AppState.settings.devise])

    const ShowElementCompo = ()=>
    {
        if(article.is_kit)
        {
        return(
        <div>
            <h3>Composition : </h3>
            <div>
            {article.kit.map((art)=>{
                return(
                    <div className="CompoArticle" style={{borderRadius:'5px'}}>
                        <div className="CompoImage" style={{borderBottom:'1px solid lightgray',marginLeft:'0px'}}>
                            <div style={{position:'absolute',marginTop:'10px',backgroundColor:'rgba(0,0,0,0.5)',padding:'5px 10px 5px 5px',borderTopRightRadius:'5px',borderBottomRightRadius:'5px'}}>
                                <Rating size={23} initialValue={2.5} />
                            </div>
                            <img onClick={e=>{LoadArticle(art.article.id)}} alt='image' src={MediaUrl(art.article.image)} /> 
                        </div>
                        <div className="CompotTitle" style={{borderBottom:'1px solid lightgray'}}>
                            <label>{art.article.title}</label>
                        </div>
                        <div style={{width:'100%'}} className="CompotQty">
                            <label style={{maxWidth:'50%',display:'inline-block'}}>Quantité : </label>
                            <input type='number' style={{width:'30%',display:'inline-block'}} defaultValue={art.quantite} />
                        </div>
                </div>   
                )
            })}
            </div>
        </div>);}
        else{return}
    }

    const AddToPanier = ()=>
    {
            let _data = {}
            const found = UserState.panier.articles.find((element) => element.article.id === article.id);
            if(found!==undefined)
            {
                _data = {id:found.id, 
                    quantity:typeof(article.quantite)==='string' ? parseInt(article.quantite) : article.quantite,
                }
                if(article.is_location)
                {_data = {..._data,location_dates:article.location_dates};console.log(_data);}
                
            }
            else{
                _data = {article:{id:article.id},quantity:article.quantite};             
                if(article.is_location)
                {_data = {..._data,location_dates:article.location_dates}; }
                //_UserState.panier.articles.push(_art);
            }

            if(UserState.auth)
            {
                fetchData.PostData(_data,'panier/item/').then((result)=>
                    {
                        console.log(result);
                        if(result.result)
                        {
                            setUserState({...UserState,panier:result.panier}); 
                    }});
            }
            else
            {
                let _UserState = UserState;
                if(found!==undefined)
                {
                    let index = _UserState.panier.articles.indexOf(found);
                    found.quantity = typeof(found.quantity)==='string' ? parseInt(found.quantity)+1 : found.quantity+1;
                    found.article = {title:article.title,id:article.id,image:article.images.length>0?article.images[0].image:null};
                    if(article.is_location)
                        found['location_dates'] = article.location_dates
                    _UserState.panier.articles[index] = found;

                }
                else
                {
                    let _art = {article:{title:article.title,id:article.id,image:article.images.length>0?article.images[0].image:null},quantity:article.quantite};             
                    if(article.is_location)
                    {_art = {..._art,location_dates:article.location_dates}; }
                    _UserState.panier.articles.push(_art);
                }   
                setUserState({...UserState,panier:_UserState.panier});
            }
    }
    
    const ShowNewAvis = ()=>
    {
        if(UserState.auth)
        {
            return(<Avis isNew={true} article={article.id} />);
        }
    }

    const BtnEdit = ()=>{
        if(UserState.is_staff)
            return(
                <div style={{width:'100%',marginBottom:'10px',display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'row'}}>
                    <input onClick={e=>{navigator(`/add-product/${id}`)}} type='button' style={{height:'40px',padding:"5px 5px 5px 5px",width:'92%',backgroundColor:'skyblue',color:'black',border:'none',borderRadius:'5px',display:'inline-block',verticalAlign:'middle'}} value={t('ajout-produit.modifier')} />
                    {/*
                    <button onClick={e=>{navigator(`/learning/article/${id}`)}} style={{background: "lightgray",verticalAlign:'middle',cursor: "pointer",margin:'5px',width:'48%',height:'50px',borderStyle:'none',borderRadius:'10px',display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'row'}}>
                        <img src={icon_rikinaze} alt="Button Icon" style={{display:'inline-block',verticalAlign:'middle',width:"35px",height:"35px",borderRadius:'25px'}} />
                        <label style={{fontSize:'small',display:'inline-block',verticalAlign:'middle',marginLeft:'0px'}}>Que dois-je savoir?</label>
                    </button>
                    
                    <div style={{width:'17%',marginLeft:'5px',display:'inline-block',verticalAlign:'middle',textAlign:'left'}}>
                        <label style={{fontSize:'medium',marginRight:'10px',display:'block',color:'gray',fontSize:'small'}}>Publié :</label>
                        <SwitchButton label="Produit Kit" checked={article.to_publish} onChange={checked=>{setArticle({...article,to_publish:checked})}} />
                    </div>
                    */}
                </div>
            );
    }

    const Promo = ()=>
    {
        if(article.promo!==null && article.promo!==undefined)
        {
            let font = 'large';
            if(isMobile)
                font = 'small';
            return(
            <>
                <span style={{color:'red',fontWeight:'normal',fontSize:font}}>{article.promo.title} de -{article.promo.reduction} %
                    jusqu'au {article.promo.end}
                </span>
            </>)
        }
    }

    const PricesView = (withDelivery)=>{
        let prix = article.price;//article.promo? (Number(article.price)-Number(article.price)*article.promo.reduction/100) : Number(article.price);
        if(!withDelivery)
            return(<>
            {(!!article.promo) && <span style={{textDecoration:'line-through',marginRight:'10px'}}>{article.promo.old_price} {' '+devise}</span>}
            <span style={{fontWeight:'bold',color:'black'}}>{prix} <i>{' '+devise}</i></span>
            </>)
        else
            {let prixWithDeliv = article.price_with_delivery ;//Number(article.delivery_price)+prix;
            return <>{prixWithDeliv} <i>{' '+devise}</i></>}

    }

    const ex = [new Date(2025,9,10),new Date(2025,9,20),new Date(2025,9,21)];

    return(
        <div id='Produit'>
            <MobileView>
                {BtnEdit()}
            </MobileView>
            <div id='DivImages'>
                <BrowserView>
                    {BtnEdit()}
                </BrowserView>
                <MobileView>
                    <div id='title'>
                        <h1 style={{fontSize:'medium', color:'black'}}>{article.title}<br/>{Promo()}</h1>
                        <h2 className='infosBlock' id='Reference'><span style={{marginRight:'20px'}}> {t('produit.reference')} : {article.id}</span> 
                        <Rating iconsCount={5} initialValue={article.note} size={10} onClick={e=>{}} readonly={true}  onPointerEnter={e=>{}} onPointerLeave={e=>{}} onPointerMove={e=>{}} /> </h2>
                    </div>
                </MobileView>
                <div id='mainImage'>
                    <img style={{width:'100%',height:'100%'}} src={mainImage} />
                </div>
                {
                    article.images.map((image,index)=>
                    {
                        return <img key={index} onClick={e=>{setMainImage(MediaUrl(image.image))}} className='subImage' src={MediaUrl(image.image)} />;
                    }
                )}
            </div>
            <div id='ProduitInfos'>
                <BrowserView>
                    <div id='title'>
                        <h1 style={{marginBottom:'0px',color:'black'}}>{article.title}<br/>{Promo()}</h1>
                        <h2 style={{marginTop:'0px'}} className='infosBlock' id='Reference'>
                            <span style={{marginRight:'50px',fontSize:'large'}}>{t('produit.reference')} : {article.id} </span> 
                            <Rating size={20} initialValue={article.note} readonly={true} onClick={e=>{}} onPointerEnter={e=>{}} onPointerLeave={e=>{}} onPointerMove={e=>{}} /> 
                        </h2>
                    </div>
                     <div id='command' style={{width:"100%"}}>
                        <div id='stock' className='infosBlock'><label style={{backgroundColor:qteStatus.color}}>{article.stock} {qteStatus.text}</label></div>
                        <div style={{display:'flex', flexDirection:'row', alignItems:'center',justifyItems:'center'}} className='infosBlock'>
                            <div style={{width:"30%"}}>
                                <label>{t('produit.quantite')} : </label>
                                <input style={{width:"30%",textAlign:'center'}} onChange={e=>{setArticle({...article,quantite:e.target.value})}} id='InputQuantity' value={article.quantite} step={1} type='number' />
                            </div>
                            { article.is_location && (
                            <div style={{width:"35%",display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <label>{t('produit.dates')} : </label><DatePicker multiple
                                                           onChange={(dates)=>{setArticle({...article,location_dates:dates.map(d=>d.toString())})}}
                                                           minDate={new Date()}
                                                           style={{width:"70%",height:'30px',marginLeft:'5px',textAlign:'center'}}
                                                            mapDays={({date})=>{
                                                                let _dates = article.excluded_location_dates.map(d=>new Date(parse_date(d.date)));
                                                                const isExcluded = _dates.some((excluded)=> date.year===excluded.getFullYear() && date.month.number===excluded.getMonth()+1 && date.day===excluded.getDate());
                                                                return {disabled:isExcluded, style: isExcluded ? {backgroundColor:'#ffcfcf',color:'gray'} : {}};}}    
                                                            format='DD/MM/YYYY' placeholder='Vos dates' />
                            </div>)
                            }
                            <div style={{width:"30%"}}>
                                <input onClick={e=>{AddToPanier();}} id='btnCommand' type='button' value={t('produit.commander')} />
                            </div>
                        </div>
                        <div id='DivDelivry' className='infosBlock'>
                            <span style={{color:'#581845'}}>
                                <img src={icon_delivery} style={{width:'40px',verticalAlign:'middle',marginRight:'20px'}} />
                                {/*t('produit.from-livraison')*/}{/*' '+TranslatedCountrie(article.delivery_from,t)*/}
                                {!!article.near_delivery && <span style={{color:'violet',fontSize:'x-small'}}>{t('vitrine.delai-livraison')} {article.near_delivery.exp}-{article.near_delivery.arr}</span>}
                                {article.near_delivery===null && <span style={{color:'violet',fontSize:'x-small',marginTop:'15px'}}>{t('vitrine.no-delivery')}</span>}
                            </span>
                        </div>
                    </div>
                </BrowserView>
                <MobileView>
                    <div id='command'>
                            <div className='infosBlock' style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                                <label >{t('produit.quantite')} : </label>
                                <input style={{width:'15%',textAlign:'center',marginLeft:'10px'}} onChange={e=>{setArticle({...article,quantite:e.target.value})}} id='InputQuantity' defaultValue={1} step={1} type='number' />
                                <label style={{color:qteStatus.color}}>{article.stock} {qteStatus.text} </label>
                                { article.is_location && (
                                    <div style={{width:"40%",display:'flex',flexDirection:'row',alignItems:'center',marginLeft:'15px'}}>
                                        <label style={{display:'block',width:'45%'}}>{t('produit.dates')} : </label>
                                        <DatePicker multiple
                                                           onChange={(dates)=>{setArticle({...article,location_dates:dates.map(d=>d.toString())})}}
                                                           minDate={new Date()}
                                                           style={{width:"70%",height:'30px',marginLeft:'5px',textAlign:'center'}}
                                                            mapDays={({date})=>{
                                                                let _dates = article.excluded_location_dates.map(d=>new Date(parse_date(d.date)));
                                                                const isExcluded = _dates.some((excluded)=> date.year===excluded.getFullYear() && date.month.number===excluded.getMonth()+1 && date.day===excluded.getDate());
                                                                return {disabled:isExcluded, style: isExcluded ? {backgroundColor:'#ffcfcf',color:'gray'} : {}};}}    
                                                            format='DD/MM/YYYY' placeholder='Vos dates' />
                                    </div>)}
                            </div>
                            <div id='DivDelivry' className='infosBlock'>
                                <span style={{color:'#581845'}}>
                                    <img src={icon_delivery} style={{width:'30px',verticalAlign:'middle',marginRight:'20px'}} />
                                    {/*t('produit.from-livraison')*/}{/*' '+TranslatedCountrie(article.delivery_from,t)*/}
                                    {!!article.near_delivery && <span style={{color:'violet',fontSize:'x-small'}}>{t('vitrine.delai-livraison')} {article.near_delivery.exp}-{article.near_delivery.arr}</span>}
                                    {article.near_delivery===null && <span style={{color:'violet',fontSize:'x-small',marginTop:'15px'}}>{t('vitrine.no-delivery')}</span>}
                                </span>
                            </div>
                            <input onClick={e=>{AddToPanier();}} id='btnCommand' type='button' value={t('produit.commander')} />
                        </div>
                </MobileView>
                <div id='paiement' className='infosBlock'>                    
                    <div id='price'>
                        <div>
                            <div style={{borderBottom:'1px solid lightgray',marginBottom:'5px'}}>
                                <span style={{fontWeight:'bold'}}>{t('produit.prix')} : </span>
                            </div>
                            <div style={{display:'inline-block',color:'lightgray'}}>
                                <h2 style={{marginBottom:'3px',marginTop:'0px',fontSize:'large'}}>{PricesView(false)}</h2>
                                <span>{t('produit.hors-livraison')}</span>
                            </div>
                            { (!!article.price_with_delivery) &&
                                <div style={{color:'darkgray',display:'inline-block',float:'right'}}>
                                    <h2 style={{marginBottom:'3px',marginTop:'3px',fontSize:'large',color:'black'}}>{PricesView(true)}</h2>
                                    <span style={{color:'black'}}>{t('produit.avec-livraison')}</span>
                                </div>
                            }
                        </div>
                    </div>
                    <div id='PaiementModes'>
                        <div>
                            <div style={{borderBottom:'1px solid lightgray',marginBottom:'5px'}}>
                                <span style={{fontWeight:'bold'}}>{t('produit.modes-paiement')} : </span>
                            </div>
                            <div style={{textAlign:'center'}}>
                                {article.payment_modes.map((paiement,index)=>{
                                    let src = "";
                                    let label = "";
                                    let width = "32px";
                                    if(paiement==="Cash")
                                    {
                                        src = icon_cash;
                                        label = t('produit.cash');
                                    }
                                    else if(paiement==='Carte Bancaire')
                                    {
                                        src  = icon_carte;
                                        label = t('produit.carte');
                                    }
                                    else if(paiement==='Paypal')
                                    {
                                        src  = icon_paypal;width="30px";
                                        label = t('produit.paypal');
                                    }
            
                                    return(
                                    <button style={{display:'inline-block',justifyContent:'center',border:'1px solid lightgray',marginRight:'10px',borderRadius:'5px',padding:'5px 10px'}}>
                                        <img key={index} src={src} style={{display:'block',margin:'auto',width:isMobile?'32px':'20px'}} />
                                        <label style={{fontSize:'xx-small'}}>{label}</label>
                                    </button>
                                    )
                                })}
                                <button style={{display:'inline-block',justifyContent:'center',border:'1px solid lightgray',borderRadius:'5px',marginRight:'10px',padding:'5px 10px'}}>
                                    <img key={'carte'} src={icon_carte} style={{display:'block',margin:'auto',marginRight:'10px',width:isMobile?'32px':'20px'}} />
                                    <label style={{fontSize:'xx-small'}}>{t('produit.carte')}</label>
                                </button>
                                <button style={{display:'inline-block',justifyContent:'center',border:'1px solid lightgray',borderRadius:'5px',padding:'5px 10px'}}>
                                    <img key={'carte'} src={icon_gifts} style={{display:'block',margin:'auto',marginRight:'10px',width:isMobile?'32px':'20px'}} />
                                    <label style={{fontSize:'xx-small'}}>{t('produit.gifts')}</label>
                                </button>
                            
                            </div>
                        </div>
                    </div>
                </div>
                <div id='description' style={{marginTop:'20px'}}>
                    <div style={{textAlign:'left'}}>
                        <h3 style={{fontSize:'medium',marginBottom:'-5px'}}>{t('produit.description')} : </h3>
                        <TextPargraph minlength={230} text={article.description} />
                    </div>
                    {ShowElementCompo()}
                    <Tabs>
                        <TabList>
                            <Tab>
                                <label style={{fontWeight:'bold'}}>{t('produit.caracteristiques')}</label>
                            </Tab>
                            <Tab>
                                <label style={{fontWeight:'bold'}}>{t('produit.documents')}</label>
                            </Tab>
                            {
                                article.is_location && UserState.auth && UserState.is_staff && (                            
                                <Tab>
                                    <label style={{fontWeight:'bold'}}>Disponibilités</label>
                                </Tab>)
                            }
                        </TabList>
                        <TabPanel>
                            <div>
                                {
                                    article.characteristics.map((car,index)=>{
                                    return(
                                        <div key={index} className='CarRow'>
                                            <span className='CarName' style={{paddingLeft:'20px'}}>{car.name}</span>
                                            <span style={{float:'right',paddingRight:'30px'}} className='CarValue'>{car.value}</span>
                                        </div>);
                                    })
                                }
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <div>
                                {
                                    article.documents.map((doc,index)=>{
                                    return(
                                        <div className='FileDownload' key={index} onClick={e=>{window.open(MediaUrl(doc.document,"_blank"))}}>
                                            <div style={{textAlign:'left',paddingLeft:'10px'}}>
                                                <label style={{verticalAlign:'middle', color:'blue'}} className='CarName'>{doc.title.replace(".pdf","")}</label>
                                            </div>
                                        </div>);
                                        })
                                }
                            </div>
                        </TabPanel>
                        { article.is_location && UserState.auth && UserState.is_staff && (
                        <TabPanel style={{textAlign:'center',margin:'auto'}}>
                            <div style={{width:'85%',margin:'auto',textAlign:'center'}}>
                                <EventCalendar eventsData={article.excluded_location_dates} />
                            </div>
                        </TabPanel>)
                        }
                    </Tabs>
                    <div style={{marginTop:'25px'}}>
                        <h3 style={{fontSize:'medium',marginBottom:'-5px'}}>{t('produit.autre-info')} : </h3>
                        <TextPargraph minlength={230} text={article.info_tech} />
                    </div>
                </div>
                <div id='avis' style={{marginBottom:'60px'}}>
                    <h3 style={{marginBottom:'0px'}}><span style={{marginRight:'20px',fontSize:'large'}}>{t('produit.avis')}</span> 
                        <Rating size={20} initialValue={article.note}  readonly={true} onClick={e=>{}} onPointerEnter={e=>{}} onPointerLeave={e=>{}} onPointerMove={e=>{}} /> ({article.note}/5)</h3>
                    {ShowNewAvis()}
                    {article.avis.map((avis)=>{
                        return <Avis isNew={false} avis={avis} />;
                    })}
                    
                </div>               
            </div>
        </div>
    )
}